import { get } from './helpers'

export default {
  emailLinkUnsubscribe(unsub_params) {
    return get(`api/email_unsubscribe/${unsub_params}`)
  }
}
